export enum DialogState {
  None = 0,
  Initialized = 1 << 0,
  BotsLoading = 1 << 1,
  Importing = 1 << 2,
  Exporting = 1 << 3,
}
